import { createContext, useReducer, useContext } from 'react';
import CameraReducer from '../reducers/CameraReducer';
import CameraState from '../data/state/CameraState';

const CameraStateContext = createContext(CameraState);
const CameraDispatchContext = createContext(null);

function CameraContextProvider({ children }) {
  const [state, dispatch] = useReducer(CameraReducer, CameraState);

  return (
    <CameraStateContext.Provider value={state}>
      <CameraDispatchContext.Provider value={dispatch}>
        {children}
      </CameraDispatchContext.Provider>
    </CameraStateContext.Provider>
  );
}

export default CameraContextProvider;

export const useCameraStateContext = () => useContext(CameraStateContext);
export const useCameraDispatchContext = () => useContext(CameraDispatchContext);